module.exports = __webpack_public_path__ + "img/InstitutFizika.31aafb67.png";